import AccountPage from "../components/AccountPage";
import AccountSettings from "../components/AccountSettings";
import OnBoarding from "../components/OnBoarding";
import AuthView from "../views/auth/AuthView";
import Index from "../views/Index";

let routes = [
  {
    path: "/auth",
    component: AuthView,
    layout: "auth",
  },
  {
    path: "/",
    component: Index,
    layout: "main",
  },
  {
    path: "/account",
    component: AccountPage,
    layout: "main",
  },
  // {
  //     path: "/on-boarding",
  //     component: OnBoarding,
  //     layout: "main",
  // },
  {
    path: "/product-demo",
    component: OnBoarding,
    layout: "main",
  },
  {
    path: "/settings",
    component: AccountSettings,
    layout: "main",
  },
];
export default routes;
